function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// eslint-disable-next-line
UtmParams = {
  utmParams: {},
  getUtmParamsFromUrl: function getUtmParamsFromUrl() {
    var self = window.location.toString();
    var queryString = self.split('?');
    if (queryString.length > 1) {
      var pairs = queryString[1].split('&');
      for (var i = 0; i < pairs.length; i++) {
        var keyVal = pairs[i].split('=');
        if (keyVal[0].includes('utm')) {
          this.utmParams[keyVal[0]] = keyVal[1];
        }
      }
    }
  },
  saveParams: function saveParams() {
    this.getUtmParamsFromUrl();
    if (Object.keys(this.utmParams).length > 0) {
      var body = JSON.stringify({
        attributes: this.utmParams
      });
      // fetch(`${routes.cart_update_url}`, {
      fetch('/cart/update', _objectSpread({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        }
      }, {
        body: body
      })).then(function (response) {
        console.log(response);
        return response.json();
      }).then(function (data) {
        console.log(data);
      });
    }
  }
};
window.addEventListener('load', function () {
  // eslint-disable-next-line
  UtmParams.saveParams();
});